import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { loadProfile } from '../redux/Profile/actions';

export const useLoadProfile = (): void => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadProfile());
  }, [dispatch]);
};
